import React, { useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import AddPackageSkeleton from "../../skeleton/addPackage";
import CLOSE from "../../../assets/images/icons/close.svg";
import MerchandiseDrawer from "./orders/admin/store/merchandiseDrawer";
import { searchAllStores } from "../../../redux/stores/storeActions";
import storeType from "../../../redux/stores/storeTypes";
import merchandiseType from "../../../redux/merchandise/merchandiseTypes";
import publicMerchandiseType from "../../../redux/publicMerchandise/publicMerchandiseTypes";
import {
  getSingleMerchandise,
  // searchAllMerchandises,
} from "../../../redux/merchandise/merchandiseActions";
import { searchPublicMerchandise } from "../../../redux/publicMerchandise/publicMerchandiseAction";

export default function AddStoreOrderModal({
  submitted,
  data,
  setData,
  displayData,
  setDisplayData,
}) {
  const dispatch = useDispatch();
  let { searchStore, searching } = useSelector((state) => state.store);
  let { SingleMerchandise } = useSelector((state) => state.merchandise);
  let { search: searchMerch } = useSelector((state) => state.publicMerchandise);

  const [errorMsg, setErrorMsg] = useState();
  const [display, setDisplay] = useState({});
  const [outlet_type, setOutletType] = useState({ product_outlet_type: "" });
  const [attributeFields, setAttributeFields] = useState([
    { attribute_id: "", quantity: 1 },
  ]);

  const [itemData, setItemData] = useState({
    product_outlet_type: "store",
    product_outlet_id: "",
    product_outlet_name: "",
    product_name: "",
    product_id: "",
    quantity: "",
    attributes: [],
  });
  const [showAttributes, setShowAttributes] = useState(false);

  const { product_id, product_outlet_id, product_outlet_name, product_name } =
    itemData;
  const { business_id, store_id, order_items } = data;
  const [open, setOpen] = useState(false);
  
  function closeModalTwo() {
    setOpen(false);
    // Clear all data when modal is closed
    setItemData({
      product_outlet_type: "store",
      product_outlet_id: "",
      product_outlet_name: "",
      product_name: "",
      product_id: "",
      quantity: "",
      attributes: [],
    });
    setDisplay({});
    setAttributeFields([{ attribute_id: "", quantity: 1 }]);
    setShowAttributes(false);
    setErrorMsg(false);

    // Clear parent data (store_id, business_id, store_name)
    setData((prevData) => ({
      ...prevData,
      store_id: undefined,
      business_id: undefined,
      store_name: undefined,
      merchandise_name: undefined,
    }));

    dispatch({ type: storeType["SEARCH_STORES"], payLoad: [] });
    dispatch({
      type: publicMerchandiseType["SEARCH_PUBLIC_MERCHANDISE"],
      payLoad: [],
    });
    dispatch({ type: merchandiseType["SHOW_A_MERCHANDISE"], payLoad: [] });
  }
  function openModalTwo() {
    setOpen(true);
  }
  const handleSearchStore = (event) => {
    event.preventDefault();
    setItemData((itemData) => ({
      ...itemData,
      product_outlet_name: event.target.value,
    }));
    const { value } = event.target;
    if (value.length >= 3) {
      dispatch(
        searchAllStores({
          search: value,
        })
      );
    } else if (value.length <= 3) {
      dispatch({ type: storeType["SEARCH_STORES"], payLoad: [] });
    }
  };

  const handleSearchMerch = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setItemData((itemData) => ({
      ...itemData,
      product_name: value,
    }));
    if (value.length >= 3 && store_id && business_id) {
      dispatch(
        searchPublicMerchandise({
          search: value,
          store_id: store_id,
          business_id: business_id,
        })
      );
    } else if (value.length <= 3) {
      dispatch({
        type: publicMerchandiseType["SEARCH_PUBLIC_MERCHANDISE"],
        payLoad: [],
      });
    }
  };

  function fillStore(result) {
    setData((data) => ({
      ...data,
      store_id: result.id,
      business_id: result.business_id,
      store_name: result.store_name,
    }));
    setItemData((itemData) => ({
      ...itemData,
      product_outlet_name: result.store_name,
    }));

    var mydiv = document.getElementById(result.id);
    if (result.id) {
      mydiv.style.borderColor = "border-[#D14522]";
    }
    dispatch({ type: storeType["SEARCH_STORES"], payLoad: [] });
  }

  function fillMerch(merch) {
    setData((data) => ({
      ...data,
      merchandise_name: merch.merchandise_name,
    }));

    setDisplay((display) => ({
      ...display,
      quantity: "1",
      merchandise_name: merch.merchandise_name,
      merchandise_amount: merch?.merchandise_amount,
    }));
    var mydiv = document.getElementById(merch.id);
    if (merch.id) {
      mydiv.style.borderColor = "border-[#D14522]";
    }

    setItemData({
      ...itemData,
      product_outlet_type: "store",
      product_outlet_id: merch.store_id,
      product_id: merch.id,
      quantity: "1",
      product_name: merch.merchandise_name,
    });

    dispatch({
      type: publicMerchandiseType["SEARCH_PUBLIC_MERCHANDISE"],
      payLoad: [],
    });

    if (merch?.merchandise_attributes) {
      dispatch(getSingleMerchandise(merch?.id));
    }
  }

  // Function to handle merchandise selection from MerchandiseDrawer
  function selectMerchandiseFromMenu(merch) {
    setData((data) => ({
      ...data,
      merchandise_name: merch.merchandise_name,
    }));

    setDisplay((display) => ({
      ...display,
      quantity: "1",
      merchandise_name: merch.merchandise_name,
      merchandise_amount: merch?.merchandise_amount,
    }));

    setItemData({
      ...itemData,
      product_outlet_type: "store",
      product_outlet_id: merch.store_id,
      product_id: merch.id,
      quantity: "1",
      product_name: merch.merchandise_name,
    });

    if (merch?.merchandise_attributes) {
      dispatch(getSingleMerchandise(merch?.id));
      setShowAttributes(true);
    } else {
      setShowAttributes(false);
    }
  }

  const handleFormChange = (index, event) => {
    let data = [...attributeFields];
    data[index][event.target.name] = event.target.value;
    setAttributeFields(data);
  };

  const addAttributeFields = () => {
    let newfield = { attribute_id: "", quantity: "" };
    setAttributeFields([...attributeFields, newfield]);
  };
  const handleSubmit = () => {
    //Check if a store and a Merchandise has been chosen if yes
    //begin the process to add chosen items to the parent array
    //else show an error to prompt user to add item
    if ((product_id, product_outlet_id)) {
      setErrorMsg(false);
      let newInput;
      // let newInput = {
      //   ...itemData,
      //   attributes: attributeFields ? attributeFields : [],
      // };
      function removeEmptyAttributes(attr) {
        return attr.filter((obj) => obj.attribute_id !== "");
      }
      const filteredAttr = removeEmptyAttributes(attributeFields);
      newInput = {
        ...itemData,
        attributes: filteredAttr,
      };
      if (product_id !== "" && outlet_type !== "") {
        order_items?.push(newInput);
      }
      setData((data) => ({
        ...data,
        order_items: order_items,
      }));

      //Generate the displayed attributes that include name and price to be set
      //to the display arr and displayed for uses to see
      let merchAttr = SingleMerchandise?.attributes?.map((e, i) => {
        let temp = attributeFields.find(
          (element) => Number(element.attribute_id) === Number(e.id)
        );
        if (temp) {
          temp.name = e.name;
          temp.amount = e.amount;
        }
        return temp;
      });

      setDisplayData((displayData) => [
        ...displayData,
        { ...display, attributes: attributeFields ? merchAttr : [] },
      ]);
      setItemData({
        product_outlet_type: "store",
        product_outlet_id: "",
        product_id: "",
        quantity: "1",
        attributes: [],
        merchandise_name: "",
        merchandise_amount: "",
        product_outlet_name: "",
        product_name: "",
      });
      setAttributeFields([{ attribute_id: "", quantity: "" }]);
      dispatch({ type: merchandiseType["SHOW_A_MERCHANDISE"], payLoad: [] });
      closeModalTwo();
    } else {
      setErrorMsg(true);
    }
  };

  return (
    <div className="Coupon" data-test="couponModal">
      <div className=" flex justify-center text-center">
        <button className="text-primary" onClick={openModalTwo}>
          Add New Item +
        </button>
      </div>

      <Transition appear show={open}>
        <Dialog as="div" className="relative z-10" onClose={closeModalTwo}>
          <Transition.Child
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className=" bg-white dark:bg-[#121212] w-[380px] text-left sm:w-[850px] p-4 sm:p-6">
                  <div>
                    <div className=" sm:block absolute top-3 right-2 pt-4 pr-4">
                      <button
                        type="button"
                        className="bg-[#ffeae5] rounded-sm p-1 sm:p-3 "
                        onClick={closeModalTwo}
                      >
                        <span className="sr-only">Close</span>
                        <img
                          src={CLOSE}
                          alt="close"
                          className=" w-3 h-3 sm:w-4 sm:h-4"
                        />
                      </button>
                    </div>

                    <div className="pb-5 text-left sm:mt-2 sm:text-left border-b border-[#E4E4F3]">
                      <Dialog.Title
                        as="p"
                        className="text-base font-meduim text-gray-500 dark:text-white"
                      >
                        Add New Item
                      </Dialog.Title>
                    </div>
                  </div>
                  <form className="py-5 mt-4 px-5 grid sm:grid-cols-2 gap-5">
                    <div>
                      <div>
                        <Input.Select
                          title={"Select Outlet type"}
                          name={"product_outlet_type"}
                          htmlFor={"product_outlet_type"}
                          onChange={(e) => {
                            setOutletType("store");
                          }}
                        >
                          <option value="store">Store</option>
                        </Input.Select>
                      </div>
                      <div className="mt-2 relative">
                        <label className="block text-sm font-medium text-[#151515] dark:text-white">
                          Store Name
                        </label>
                        <input
                          type={"search"}
                          name={"store_id"}
                          htmlFor={"store_id"}
                          onChange={handleSearchStore}
                          value={product_outlet_name}
                          autoComplete="off"
                          className={
                            "mt-2 block pl-3 pr-10 w-full text-base bg-gray-100 focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 mb-4 border border-gray-300 "
                          }
                          placeholder={"Search Store Name"}
                        />
                        {(submitted || errorMsg) && !product_outlet_id && (
                          <div className="text-primary text-xs -mt-4 mb-3">
                            Store is required
                          </div>
                        )}
                        {searching ? (
                          <div className="absolute w-full bg-white dark:bg-[#121212] shadow z-10 top-[68px]">
                            <div className="p-3">
                              <AddPackageSkeleton />
                            </div>
                          </div>
                        ) : (
                          searchStore &&
                          Array.isArray(searchStore) && (
                            <div className="absolute w-full bg-white dark:bg-[#121212] shadow top-[68px] z-10">
                              {searchStore?.map((result, index) => (
                                <div
                                  className="px-3 py-2 border border-primary mb-2"
                                  id={result.id}
                                  key={index}
                                  onClick={() => fillStore(result)}
                                >
                                  <div className="grid-cols-2">
                                    <div className="col-span-1">
                                      <h6>Name: {result.store_name}</h6>
                                    </div>
                                    <div className="col-span-1">
                                      <h6>Phone: {result.store_phone}</h6>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )
                        )}
                      </div>

                      <div className="mt-2 relative">
                        <label className="block text-sm font-medium text-[#151515] dark:text-white">
                          Merchandise Items
                        </label>
                        <input
                          type={"search"}
                          name={"product_id"}
                          htmlFor={"product_id"}
                          onChange={handleSearchMerch}
                          value={product_name}
                          autoComplete="off"
                          className={
                            "mt-2 block pl-3 pr-10 w-full text-base bg-gray-100 focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 mb-4 border border-gray-300 "
                          }
                          placeholder={"Search Merchandise Item"}
                        />
                        {(submitted || errorMsg) && !product_id && (
                          <div className="text-primary text-xs -mt-4 mb-3">
                            merchandise is required
                          </div>
                        )}
                        {searchMerch &&
                          Array.isArray(searchMerch) && (
                            <div className="absolute w-full bg-white dark:bg-[#121212] shadow top-[68px] z-10">
                              {searchMerch?.map((merch, index) => (
                                <div
                                  className="px-3 py-2 border border-primary mb-2"
                                  id={merch.id}
                                  key={index}
                                  onClick={() => fillMerch(merch)}
                                >
                                  <div className="grid-cols-2">
                                    <div className="col-span-1">
                                      <h6>Name: {merch.merchandise_name}</h6>
                                    </div>
                                    <div className="col-span-1">
                                      <h6>
                                        Category: {merch.merchandise_categories}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                      </div>

                      <p className="text-sm mb-5 -mt-2">
                        Search and add a customers merchandise items, only merchandise
                        registered under{" "}
                        <span className="text-primary">
                          {data?.store_name ?? "Selected Store"}
                        </span>{" "}
                        will show here.
                      </p>
                      {SingleMerchandise?.attributes?.length > 0 && (
                        <>
                          {attributeFields.map((input, index) => (
                            <div className="grid grid-cols-2 gap-8" key={index}>
                              <Input.Select
                                title={"Attribute"}
                                name="attribute_id"
                                id="attribute_id"
                                value={input.attribute_id}
                                onChange={(event) =>
                                  handleFormChange(index, event)
                                }
                                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                              >
                                <option>Select attribute</option>
                                {SingleMerchandise?.attributes?.map(
                                  (item, index) => (
                                    <option key={index} value={item.id}>
                                      {item.name}
                                    </option>
                                  )
                                )}
                              </Input.Select>
                              <Input.Number
                                title={"Quantity"}
                                name="quantity"
                                id="quantity"
                                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                                placeholder="Enter quantity"
                                defaultValue={1}
                                min={1}
                                value={input.quantity}
                                onChange={(event) =>
                                  handleFormChange(index, event)
                                }
                              />
                            </div>
                          ))}

                          {SingleMerchandise?.attributes?.length > 1 && (
                            <div className="w-full flex justify-end">
                              <button
                                type="button"
                                onClick={addAttributeFields}
                                className="text-[#CE2600B2]"
                              >
                                Add more +
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>

                    <div className="hidden sm:block">
                      <MerchandiseDrawer
                        data={data}
                        onMerchandiseSelect={selectMerchandiseFromMenu}
                        showAttributes={showAttributes}
                        setShowAttributes={setShowAttributes}
                        singleMerchandise={SingleMerchandise}
                        attributeFields={attributeFields}
                        handleFormChange={handleFormChange}
                        addAttributeFields={addAttributeFields}
                      />
                    </div>
                  </form>

                  <div className="py-8 max-w-sm mx-auto flex justify-center text-center">
                    <Button.Primary
                      title={"Add Item"}
                      className="px-4 rounded-sm"
                      onClick={handleSubmit}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
